// import React, { useEffect, useRef, useState } from "react";
// import BuildIcon from "@mui/icons-material/Build";
// import EnergySavingsLeafIcon from "@mui/icons-material/EnergySavingsLeaf";
// import ArticleIcon from "@mui/icons-material/Article";
// import LocalShippingIcon from "@mui/icons-material/LocalShipping";
// import ShieldIcon from "@mui/icons-material/Shield";
// import FactoryIcon from "@mui/icons-material/Factory";
// import Inventory2Icon from "@mui/icons-material/Inventory2";
// import CategoryIcon from "@mui/icons-material/Category";
// import { Science } from "@mui/icons-material";
// import { getSubModulesByRoleId } from "store";
// import Cookies from "universal-cookie";
// import { connect } from "react-redux";

// const cookies = new Cookies();

// const DesktopTimelineSlider = ({
//   getSubModulesByRoleId,
//   getSubModulesByRoleIdReducer,
//   steps,
//   openStep,
//   openStepForTechnicalDocuments,
//   openStepForDurability,
//   openStepForRawMaterial,
//   openStepForPWM,
//   openStepForEvt,
//   openStepForCOC,
//   openStepForManufacturing,
//   openStepForRCV,
//   openStepForProductTests,
//   mainData,
// }) => {
//   const trackRef = useRef(null);
//   const [activeIndex, setActiveIndex] = useState(0);

//   // Sync dots with current snap
//   useEffect(() => {
//     const track = trackRef.current;
//     if (!track) return;

//     let rafId;
//     const onScroll = () => {
//       if (rafId) cancelAnimationFrame(rafId);
//       rafId = requestAnimationFrame(() => {
//         const first = track.querySelector(".step");
//         const gap = 24; // keep in sync with CSS
//         if (first) {
//           const cardW = first.offsetWidth + gap;
//           const idx = Math.round(track.scrollLeft / cardW);
//           setActiveIndex(Math.max(0, Math.min(steps?.length - 1, idx)));
//         }
//       });
//     };

//     track.addEventListener("scroll", onScroll, { passive: true });
//     return () => {
//       track.removeEventListener("scroll", onScroll);
//       if (rafId) cancelAnimationFrame(rafId);
//     };
//   }, [steps?.length]);

//   const scrollToIndex = (index) => {
//     const track = trackRef.current;
//     if (!track) return;
//     const first = track.querySelector(".step");
//     const gap = 24;
//     const clamped = Math.max(0, Math.min(steps?.length - 1, index));
//     const delta = first ? clamped * (first.offsetWidth + gap) : clamped * 360;
//     track.scrollTo({ left: delta, behavior: "smooth" });
//     setActiveIndex(clamped);
//   };

//   const scrollByOne = (dir) => scrollToIndex(activeIndex + dir);
//   let loginDetails = cookies.get("loginDetailsForWMS");

//   let jwtToken = loginDetails?.jwt;

//   let roleId = loginDetails?.data?.roleId;
//   useEffect(() => {
//     getSubModulesByRoleId(roleId, jwtToken);
//   }, [roleId]);

//   const [modulesData, setModulesData] = useState([]);

//   useEffect(() => {
//     setModulesData(
//       getSubModulesByRoleIdReducer.subModulesByRoleData.data
//         ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
//         : [],
//     );
//   }, [getSubModulesByRoleIdReducer]);

//   let packagingModule = modulesData.find(
//     (moduleId) => moduleId.moduleId == "7e02c688-4e21-4805-9f51-2320dda92382",
//   );

//   let viewPackaging = packagingModule
//     ? packagingModule.actionId.includes("825e65a6-0f01-4fe7-91a1-63cb571b093a")
//     : null;

//   let productTestingModule = modulesData.find(
//     (moduleId) => moduleId.moduleId == "16cc0217-cbce-4e3f-874b-89b3fbdd0232",
//   );

//   let viewProductTesting = productTestingModule
//     ? productTestingModule.actionId.includes(
//       "896c7b19-7fe5-4306-9f06-2735e57a7b84",
//     )
//     : null;

//   let durabilityModule = modulesData.find(
//     (moduleId) => moduleId.moduleId == "5e690abe-d7a1-4e45-8782-43409b4edab2",
//   );

//   let viewDurability = durabilityModule
//     ? durabilityModule.actionId.includes("24059d11-ee70-4a0d-a132-56bf7195de49")
//     : null;

//   let cocModule = modulesData.find(
//     (moduleId) => moduleId.moduleId == "269b317f-3fc3-4ce8-b885-0817acf36a66",
//   );

//   let viewCoc = cocModule
//     ? cocModule.actionId.includes("1f130e9a-11bf-4ad3-b690-4fcefedfbb44")
//     : null;

//   let rmModule = modulesData.find(
//     (moduleId) => moduleId.moduleId == "852fd581-2cd9-40d1-b0f6-e29dd61566ff",
//   );

//   let viewRm = rmModule
//     ? rmModule.actionId.includes("94e1aedf-8637-4d27-9079-2812f320e458")
//     : null;

//   let repairValueModule = modulesData.find(
//     (moduleId) => moduleId.moduleId == "9f3b7cf0-eb97-4567-8d4a-711868269662",
//   );

//   let viewRepairValue = repairValueModule
//     ? repairValueModule.actionId.includes(
//       "a0f6b96e-282c-4349-b655-f08f172739f8",
//     )
//     : null;

//   let manufacturingModule = modulesData.find(
//     (moduleId) => moduleId.moduleId == "d51e5caa-b714-4739-877a-3b78d6f9d263",
//   );

//   let viewManufacturing = manufacturingModule
//     ? manufacturingModule.actionId.includes(
//       "6fd9218e-53e3-49ec-85bc-ef986f9ede86",
//     )
//     : null;

//   let validationModule = modulesData.find(
//     (moduleId) => moduleId.moduleId == "b3605909-30dc-4c9f-8918-f1ef34354fd2",
//   );

//   let viewValidation = validationModule
//     ? validationModule.actionId.includes("acf6e194-8a3f-4c7f-98b7-9cc2151ed763")
//     : null;

//   let socialComplianceModule = modulesData.find(
//     (moduleId) => moduleId.moduleId == "013a3276-d1db-4051-b489-b199b4710cf4",
//   );

//   let viewSocialCompliance = socialComplianceModule
//     ? socialComplianceModule.actionId.includes(
//       "3dce3a16-274c-4937-92cc-df13fa7c6c8d",
//     )
//     : null;

//   return (
//     <>
//       <style>{`
//         /* DESKTOP slider styles */
//         @media (min-width: 901px) {
//           .desktop-slider {
//             display: grid;
//             grid-template-rows: auto auto auto;
//             gap: 12px;
//             margin-top: -20px
//           }
//           .desktop-controls {
//             display: flex; justify-content: space-between; align-items: center;
//             gap: 8px; padding: 0 6px;
//           }
//           .desktop-btn {
//             display: inline-flex; align-items: center; justify-content: center;
//             width: 38px; height: 38px; border-radius: 50%; border: none;
//             background: #f5f5f5; color: #0f172a; cursor: pointer;
//             box-shadow: 0 8px 20px rgba(2,6,23,0.06);
//           }
//           .desktop-btn:disabled { opacity: 0.45; cursor: not-allowed; }

//           .desktop-track {
//             display: flex;
//             gap: 24px;
//             overflow-x: auto;
//             padding: 10px 6px;
//             scroll-snap-type: x mandatory;
//             -webkit-overflow-scrolling: touch;
//           }
//           .desktop-track::-webkit-scrollbar { height: 10px; }
//           .desktop-track::-webkit-scrollbar-thumb {
//             background: rgba(2,6,23,0.16); border-radius: 999px;
//           }

//           /* Each timeline card is a snap item */
//           .desktop-track .step {
//             scroll-snap-align: start;
//             min-width: 360px; /* adjust to taste */
//             flex-shrink: 0;
//             /* keep your existing card styles; this just ensures width and snap */
//           }

//           .desktop-dots {
//             display: flex; align-items: center; justify-content: center;
//             gap: 8px; padding-bottom: 6px;
//           }
//           .desktop-dot {
//             width: 9px; height: 9px; border-radius: 50%;
//             background: rgba(2,6,23,0.18); border: none; cursor: pointer;
//           }
//           .desktop-dot.active { background: #0f172a; }
//         }


//         @media (max-width: 900px) {
//   .desktop-slider { 
//     display: block !important; 
//     width: 100%;
//     margin-top: 0px;
//   }
//   .desktop-track {
//     display: flex !important;
//     gap: 16px;
//     padding: 10px;
//     overflow-x: auto; /* Mobile par horizontal scroll allow karega */
//     -webkit-overflow-scrolling: touch;
//     scroll-snap-type: x mandatory;
//   }
//   .desktop-track .step {
//     flex-shrink: 0;
//     min-width: 260px; /* Card ko chota nahi hone dega */
//     scroll-snap-align: start;
//   }
//   .desktop-controls, .desktop-dots {
//     display: none !important; /* Mobile par buttons hide karke touch scroll rakha hai */
//   }
// }
//       `}</style>

//       <style>{`
//                 .plg-container {
//                     font-family: Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
//                     background: "white" ;
//                     border: 1px solid rgba(59,130,246,0.08);
//                     border-radius: 12px;
//                     padding: 20px;
//                     box-shadow: 0 6px 18px rgba(2,6,23,0.06);
//                 }
//                 .plg-header h3 { margin: 0; font-size: 18px; color: #0f172a; }
//                 .plg-header small { color: #6b7280; }

//                 .timeline-wrap { position: relative; margin-top: 20px; padding: 36px 12px 20px; background: transparent; }
//                 .timeline-line {
//                     position: absolute;
//                     left: 48px;
//                     right: 48px;
//                     top: 72px;
//                     height: 6px;
//                     background: linear-gradient(90deg,#bbdefb,#c8f7e6);
//                     border-radius: 4px;
//                     filter: blur(0.2px);

//                 }

//                 .steps {
//                     display: flex;
//                     gap: 40px;
//                     align-items: flex-start;
//                     justify-content: space-between;
//                     position: relative;
//                 }
//                 .step {
//                     display: flex;
//                     flex-direction: column;
//                     align-items: center;
//                     width: "300px";
//                     min-width: 170px;
//                     z-index: 999;
//                 }

//                 .icon-wrap { position: relative; margin-bottom: 12px; }
//                 .icon-circle {
//                     width: 86px;
//                     height: 86px;
//                     border-radius: 50%;
//                     background: linear-gradient(180deg,#05b85b,#00b74a);
//                     display: flex;
//                     align-items: center;
//                     justify-content: center;
//                     box-shadow: 0 6px 20px rgba(3,102,67,0.12), inset 0 4px 0 rgba(255,255,255,0.12);
//                 }
//                 .icon-circle svg { display: block; }

//                 .step-number {
//                     position: absolute;
//                     top: -8px;
//                     right: -8px;
//                     width: 28px;
//                     height: 28px;
//                     border-radius: 50%;
//                     background: #fff;
//                     border: 3px solid rgba(99,102,241,0.8);
//                     display: flex;
//                     align-items: center;
//                     justify-content: center;
//                     font-weight: 600;
//                     color: #374151;
//                     box-shadow: 0 4px 10px rgba(2,6,23,0.08);
//                 }

//                 .card {
//                     margin-top: 12px;
//                     background: #fff;
//                     width: "fit-content";
//                     border-radius: 10px;
//                     padding: 6px 12px;
//                     box-shadow: 0 8px 20px rgba(2,6,23,0.04);
//                     text-align: center;
//                 }
//                 .card-title { color: #0f172a; font-weight: 600; margin-bottom: -5px; font-size: 14px; width: fit-content; margin-left: auto; margin-right: auto; }
//                 .pill {
//                     display: inline-block;
//                     padding: 5px;
//                     border-radius: 5px;
//                     font-size: 12px;
//                     border: 2px solid;
//                     background: rgba(255,255,255,0.98);
//                     font-weight: 600;
//                 }

//                 .hl-connector {
//   width: 2px;
//   height: 82px;      
//   margin-top: 32px;
//   margin-bottom: -82px;    
//   background: rgba(16, 185, 129, 0.30);
//                }  

//                 /* responsive */
//                 @media (max-width: 900px) {
//                     .steps { gap: 24px; overflow-x: auto; padding-bottom: 8px; }
//                     .timeline-line { left: 16px; right: 16px; top: 116px; }
//                 }
//             `}</style>

//       <div
//         className="desktop-slider"
//         aria-label="Desktop timeline slider"
//         style={{ marginTop: "20px" }}
//       >
//         {/* <div className="desktop-controls">
//           <button
//             type="button"
//             className="desktop-btn"
//             aria-label="Previous"
//             onClick={() => scrollByOne(-1)}
//             disabled={activeIndex === 0}
//           >
//             ◀
//           </button>
//           <button
//             type="button"
//             className="desktop-btn"
//             aria-label="Next"
//             onClick={() => scrollByOne(1)}
//             disabled={activeIndex >= steps.length - 1}
//           >
//             ▶
//           </button>
//         </div> */}

//         <div className="desktop-track" ref={trackRef} role="list">
//           {/* Reuse your existing desktop .step markup */}
//           {viewManufacturing && (
//             <>
//               {!mainData?.productLifecycleJourney?.manufacturer.orderNumber ||
//                 mainData?.productLifecycleJourney?.manufacturer.orderNumber ==
//                 "n/a" ||
//                 mainData?.productLifecycleJourney?.manufacturer.orderNumber ==
//                 "" ? (
//                 <div
//                   className="step"
//                   style={{ cursor: "default" }}
//                   role="listitem"
//                   aria-label={`Step ${mainData?.productLifecycleJourney?.manufacturer?.dppId}: ${mainData?.productLifecycleJourney?.manufacturer?.dppId}`}
//                 >
//                   <div className="icon-wrap" style={{ marginBottom: "10px" }}>
//                     <div
//                       className="icon-circle "
//                       style={{
//                         background: "grey",
//                       }}
//                     >
//                       <svg
//                         width="36"
//                         height="36"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="#fff"
//                         strokeWidth="1.6"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       >
//                         <Inventory2Icon color="white" />
//                       </svg>
//                     </div>
//                   </div>

//                   <div
//                     className="timeline-line"
//                     style={{ marginTop: "80px" }}
//                   />
//                   <div className="hl-connector"></div>
//                   <div
//                     className="card "
//                     style={{
//                       display: "flex",
//                       flexDirection: "column",
//                       alignItems: "center",
//                       marginTop: "80px",
//                       boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
//                       padding: "20px",
//                     }}
//                   >
//                     <div
//                       className="card-title"
//                       style={{ marginBottom: "20px" }}
//                     >
//                       {mainData?.productLifecycleJourney?.manufacturer.name}
//                     </div>
//                     <div
//                       className="pill"
//                       style={{
//                         borderColor: "#A78BFA",
//                         color: "#A78BFA",
//                         marginBottom: "10px",
//                       }}
//                     >
//                       Not Available
//                     </div>
//                   </div>
//                 </div>
//               ) : (
//                 <div
//                   className="step"
//                   onClick={() => openStepForManufacturing()}
//                   style={{ cursor: "pointer" }}
//                   role="listitem"
//                   aria-label={`Step ${mainData?.productLifecycleJourney?.manufacturer?.dppId}: ${mainData?.productLifecycleJourney?.manufacturer?.dppId}`}
//                 >
//                   <div className="icon-wrap" style={{ marginBottom: "10px" }}>
//                     <div
//                       className="icon-circle timeline-icon"
//                       style={{
//                         background: "#FF5F15",
//                       }}
//                     >
//                       <svg
//                         width="36"
//                         height="36"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="#fff"
//                         strokeWidth="1.6"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       >
//                         <Inventory2Icon color="white" />
//                       </svg>
//                     </div>
//                     <div className="step-number">
//                       {
//                         mainData?.productLifecycleJourney?.manufacturer
//                           .orderNumber
//                       }
//                     </div>
//                   </div>

//                   <div
//                     className="timeline-line"
//                     style={{ marginTop: "80px" }}
//                   />
//                   <div className="hl-connector"></div>
//                   <div
//                     className="card timeline-icon2"
//                     style={{
//                       display: "flex",
//                       flexDirection: "column",
//                       alignItems: "center",
//                       marginTop: "80px",
//                       boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
//                       padding: "20px",
//                     }}
//                   >
//                     <div
//                       className="card-title"
//                       style={{ marginBottom: "20px" }}
//                     >
//                       {mainData?.productLifecycleJourney?.manufacturer.name}
//                     </div>
//                     <div
//                       className="pill"
//                       style={{
//                         borderColor: "#A78BFA",
//                         color: "#A78BFA",
//                         marginBottom: "10px",
//                       }}
//                     >
//                       {mainData?.productLifecycleJourney?.manufacturer.status
//                         ? mainData?.productLifecycleJourney?.manufacturer.status
//                         : "-"}
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </>
//           )}

//           {viewRm && (
//             <>
//               {!mainData?.productLifecycleJourney?.rmTraceability.orderNumber ||
//                 mainData?.productLifecycleJourney?.rmTraceability.orderNumber ==
//                 "n/a" ||
//                 mainData?.productLifecycleJourney?.rmTraceability.orderNumber ==
//                 "" ? (
//                 <div
//                   className="step"
//                   style={{ cursor: "default" }}
//                   role="listitem"
//                   aria-label={`Step ${mainData?.productLifecycleJourney?.rmTraceability?.dppId}: ${mainData?.productLifecycleJourney?.rmTraceability?.dppId}`}
//                 >
//                   <div className="icon-wrap" style={{ marginBottom: "10px" }}>
//                     <div
//                       className="icon-circle "
//                       style={{
//                         background: "grey",
//                       }}
//                     >
//                       <svg
//                         width="36"
//                         height="36"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="#fff"
//                         strokeWidth="1.6"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       >
//                         <CategoryIcon color="white" />
//                       </svg>
//                     </div>
//                   </div>

//                   <div
//                     className="timeline-line"
//                     style={{ marginTop: "80px" }}
//                   />
//                   <div className="hl-connector"></div>
//                   <div
//                     className="card "
//                     style={{
//                       display: "flex",
//                       flexDirection: "column",
//                       alignItems: "center",
//                       marginTop: "80px",
//                       boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
//                       padding: "20px",
//                     }}
//                   >
//                     <div
//                       className="card-title"
//                       style={{ marginBottom: "20px" }}
//                     >
//                       {mainData?.productLifecycleJourney?.rmTraceability.name}
//                     </div>
//                     <div
//                       className="pill"
//                       style={{
//                         borderColor: "#A78BFA",
//                         color: "#A78BFA",
//                         marginBottom: "10px",
//                       }}
//                     >
//                       Not Available
//                     </div>
//                   </div>
//                 </div>
//               ) : (
//                 <div
//                   className="step"
//                   onClick={() => openStepForRawMaterial()}
//                   style={{ cursor: "pointer" }}
//                   role="listitem"
//                   aria-label={`Step ${mainData?.productLifecycleJourney?.rmTraceability?.dppId}: ${mainData?.productLifecycleJourney?.rmTraceability?.dppId}`}
//                 >
//                   <div className="icon-wrap" style={{ marginBottom: "10px" }}>
//                     <div
//                       className="icon-circle timeline-icon"
//                       style={{
//                         background: "#0000FF",
//                       }}
//                     >
//                       <svg
//                         width="36"
//                         height="36"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="#fff"
//                         strokeWidth="1.6"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       >
//                         <CategoryIcon color="white" />
//                       </svg>
//                     </div>
//                     <div className="step-number">
//                       {
//                         mainData?.productLifecycleJourney?.rmTraceability
//                           .orderNumber
//                       }
//                     </div>
//                   </div>

//                   <div
//                     className="timeline-line"
//                     style={{ marginTop: "80px" }}
//                   />
//                   <div className="hl-connector"></div>
//                   <div
//                     className="card timeline-icon2"
//                     style={{
//                       display: "flex",
//                       flexDirection: "column",
//                       alignItems: "center",
//                       marginTop: "80px",
//                       boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
//                       padding: "20px",
//                     }}
//                   >
//                     <div
//                       className="card-title"
//                       style={{ marginBottom: "20px" }}
//                     >
//                       {mainData?.productLifecycleJourney?.rmTraceability.name}
//                     </div>
//                     <div
//                       className="pill"
//                       style={{
//                         borderColor: "#A78BFA",
//                         color: "#A78BFA",
//                         marginBottom: "10px",
//                       }}
//                     >
//                       {mainData?.productLifecycleJourney?.rmTraceability.status
//                         ? mainData?.productLifecycleJourney?.rmTraceability
//                           .status
//                         : "-"}
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </>
//           )}

//           {viewProductTesting && (
//             <>
//               {mainData?.productLifecycleJourney?.productTests.orderNumber ==
//                 "n/a" ||
//                 mainData?.productLifecycleJourney?.productTests.orderNumber ==
//                 "" ? (
//                 <div
//                   className="step"
//                   style={{ cursor: "default" }}
//                   role="listitem"
//                   aria-label={`Step ${mainData?.productLifecycleJourney?.productTests?.dppId}: ${mainData?.productLifecycleJourney?.productTests?.dppId}`}
//                 >
//                   <div className="icon-wrap" style={{ marginBottom: "10px" }}>
//                     <div
//                       className="icon-circle "
//                       style={{
//                         background: "grey",
//                       }}
//                     >
//                       <svg
//                         width="36"
//                         height="36"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="#fff"
//                         strokeWidth="1.6"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       >
//                         <Science color="white" />
//                       </svg>
//                     </div>
//                   </div>

//                   <div
//                     className="timeline-line"
//                     style={{ marginTop: "80px" }}
//                   />
//                   <div className="hl-connector"></div>
//                   <div
//                     className="card "
//                     style={{
//                       display: "flex",
//                       flexDirection: "column",
//                       alignItems: "center",
//                       marginTop: "80px",
//                       boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
//                       padding: "20px",
//                     }}
//                   >
//                     <div
//                       className="card-title"
//                       style={{ marginBottom: "20px" }}
//                     >
//                       {mainData?.productLifecycleJourney?.productTests.name}
//                     </div>
//                     <div
//                       className="pill"
//                       style={{
//                         borderColor: "#A78BFA",
//                         color: "#A78BFA",
//                         marginBottom: "10px",
//                       }}
//                     >
//                       Not Available
//                     </div>
//                   </div>
//                 </div>
//               ) : (
//                 <div
//                   className="step"
//                   onClick={() => openStepForProductTests()}
//                   style={{ cursor: "pointer" }}
//                   role="listitem"
//                   aria-label={`Step ${mainData?.productLifecycleJourney?.productTests?.dppId}: ${mainData?.productLifecycleJourney?.productTests?.dppId}`}
//                 >
//                   <div className="icon-wrap" style={{ marginBottom: "10px" }}>
//                     <div
//                       className="icon-circle timeline-icon"
//                       style={{
//                         background: "black",
//                       }}
//                     >
//                       <svg
//                         width="36"
//                         height="36"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="#fff"
//                         strokeWidth="1.6"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       >
//                         <Science color="white" />
//                       </svg>
//                     </div>
//                     <div className="step-number">
//                       {
//                         mainData?.productLifecycleJourney?.productTests
//                           .orderNumber
//                       }
//                     </div>
//                   </div>

//                   <div
//                     className="timeline-line"
//                     style={{ marginTop: "80px" }}
//                   />
//                   <div className="hl-connector"></div>
//                   <div
//                     className="card timeline-icon2"
//                     style={{
//                       display: "flex",
//                       flexDirection: "column",
//                       alignItems: "center",
//                       marginTop: "80px",
//                       boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
//                       padding: "20px",
//                     }}
//                   >
//                     <div
//                       className="card-title"
//                       style={{ marginBottom: "20px" }}
//                     >
//                       {mainData?.productLifecycleJourney?.productTests.name}
//                     </div>
//                     <div
//                       className="pill"
//                       style={{
//                         borderColor: "#A78BFA",
//                         color: "#A78BFA",
//                         marginBottom: "10px",
//                       }}
//                     >
//                       {mainData?.productLifecycleJourney?.productTests.status
//                         ? mainData?.productLifecycleJourney?.productTests.status
//                         : "-"}
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </>
//           )}

//           {viewValidation && (
//             <>
//               {mainData?.productLifecycleJourney?.technicalDocuments
//                 .orderNumber == "n/a" ||
//                 mainData?.productLifecycleJourney?.technicalDocuments
//                   .orderNumber == "" ? (
//                 <div
//                   className="step"
//                   style={{ cursor: "default" }}
//                   role="listitem"
//                   aria-label={`Step ${mainData?.productLifecycleJourney?.technicalDocuments?.dppId}: ${mainData?.productLifecycleJourney?.technicalDocuments?.dppId}`}
//                 >
//                   <div className="icon-wrap" style={{ marginBottom: "10px" }}>
//                     <div
//                       className="icon-circle "
//                       style={{
//                         background: "grey",
//                       }}
//                     >
//                       <svg
//                         width="36"
//                         height="36"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="#fff"
//                         strokeWidth="1.6"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       >
//                         <ArticleIcon color="white" />
//                       </svg>
//                     </div>
//                   </div>

//                   <div
//                     className="timeline-line"
//                     style={{ marginTop: "80px" }}
//                   />
//                   <div className="hl-connector"></div>
//                   <div
//                     className="card "
//                     style={{
//                       display: "flex",
//                       flexDirection: "column",
//                       alignItems: "center",
//                       marginTop: "80px",
//                       boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
//                       padding: "20px",
//                     }}
//                   >
//                     <div
//                       className="card-title"
//                       style={{ marginBottom: "20px" }}
//                     >
//                       {
//                         mainData?.productLifecycleJourney?.technicalDocuments
//                           .name
//                       }
//                     </div>
//                     <div
//                       className="pill"
//                       style={{
//                         borderColor: "#A78BFA",
//                         color: "#A78BFA",
//                         marginBottom: "10px",
//                       }}
//                     >
//                       Not Available
//                     </div>
//                   </div>
//                 </div>
//               ) : (
//                 <div
//                   className="step"
//                   onClick={() => openStepForTechnicalDocuments()}
//                   style={{ cursor: "pointer" }}
//                   role="listitem"
//                   aria-label={`Step ${mainData?.productLifecycleJourney?.technicalDocuments?.dppId}: ${mainData?.productLifecycleJourney?.technicalDocuments?.dppId}`}
//                 >
//                   <div className="icon-wrap" style={{ marginBottom: "10px" }}>
//                     <div
//                       className="icon-circle timeline-icon"
//                       style={{
//                         background: "#F59E0B",
//                       }}
//                     >
//                       <svg
//                         width="36"
//                         height="36"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="#fff"
//                         strokeWidth="1.6"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       >
//                         <ArticleIcon color="white" />
//                       </svg>
//                     </div>
//                     <div className="step-number">
//                       {
//                         mainData?.productLifecycleJourney?.technicalDocuments
//                           .orderNumber
//                       }
//                     </div>
//                   </div>

//                   <div
//                     className="timeline-line"
//                     style={{ marginTop: "80px" }}
//                   />
//                   <div className="hl-connector"></div>
//                   <div
//                     className="card timeline-icon2"
//                     style={{
//                       display: "flex",
//                       flexDirection: "column",
//                       alignItems: "center",
//                       marginTop: "80px",
//                       boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
//                       padding: "20px",
//                     }}
//                   >
//                     <div
//                       className="card-title"
//                       style={{ marginBottom: "20px" }}
//                     >
//                       {
//                         mainData?.productLifecycleJourney?.technicalDocuments
//                           .name
//                       }
//                     </div>
//                     <div
//                       className="pill"
//                       style={{
//                         borderColor: "#A78BFA",
//                         color: "#A78BFA",
//                         marginBottom: "10px",
//                       }}
//                     >
//                       {
//                         mainData?.productLifecycleJourney?.technicalDocuments
//                           .status
//                       }
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </>
//           )}

//           {viewCoc && (
//             <>
//               {mainData?.productLifecycleJourney?.chainOfCustody.orderNumber ==
//                 "n/a" ||
//                 mainData?.productLifecycleJourney?.chainOfCustody.orderNumber ==
//                 "" ? (
//                 <div
//                   className="step"
//                   style={{ cursor: "default" }}
//                   role="listitem"
//                   aria-label={`Step ${mainData?.productLifecycleJourney?.chainOfCustody?.dppId}: ${mainData?.productLifecycleJourney?.chainOfCustody?.dppId}`}
//                 >
//                   <div className="icon-wrap" style={{ marginBottom: "10px" }}>
//                     <div
//                       className="icon-circle "
//                       style={{
//                         background: "grey",
//                       }}
//                     >
//                       <svg
//                         width="36"
//                         height="36"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="#fff"
//                         strokeWidth="1.6"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       >
//                         <LocalShippingIcon color="white" />
//                       </svg>
//                     </div>
//                   </div>

//                   <div
//                     className="timeline-line"
//                     style={{ marginTop: "80px" }}
//                   />
//                   <div className="hl-connector"></div>
//                   <div
//                     className="card "
//                     style={{
//                       display: "flex",
//                       flexDirection: "column",
//                       alignItems: "center",
//                       marginTop: "80px",
//                       boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
//                       padding: "20px",
//                     }}
//                   >
//                     <div
//                       className="card-title"
//                       style={{ marginBottom: "20px" }}
//                     >
//                       {mainData?.productLifecycleJourney?.chainOfCustody.name}
//                     </div>
//                     <div
//                       className="pill"
//                       style={{
//                         borderColor: "#A78BFA",
//                         color: "#A78BFA",
//                         marginBottom: "10px",
//                       }}
//                     >
//                       Not Available
//                     </div>
//                   </div>
//                 </div>
//               ) : (
//                 <div
//                   className="step"
//                   onClick={() => openStepForCOC()}
//                   style={{ cursor: "pointer" }}
//                   role="listitem"
//                   aria-label={`Step ${mainData?.productLifecycleJourney?.chainOfCustody?.dppId}: ${mainData?.productLifecycleJourney?.chainOfCustody?.dppId}`}
//                 >
//                   <div className="icon-wrap" style={{ marginBottom: "10px" }}>
//                     <div
//                       className="icon-circle timeline-icon"
//                       style={{
//                         background:
//                           mainData?.productLifecycleJourney?.chainOfCustody
//                             ?.badgeColor,
//                       }}
//                     >
//                       <svg
//                         width="36"
//                         height="36"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="#fff"
//                         strokeWidth="1.6"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       >
//                         <LocalShippingIcon color="white" />
//                       </svg>
//                     </div>
//                     <div className="step-number">
//                       {
//                         mainData?.productLifecycleJourney?.chainOfCustody
//                           .orderNumber
//                       }
//                     </div>
//                   </div>

//                   <div
//                     className="timeline-line"
//                     style={{ marginTop: "80px" }}
//                   />
//                   <div className="hl-connector"></div>
//                   <div
//                     className="card timeline-icon2"
//                     style={{
//                       display: "flex",
//                       flexDirection: "column",
//                       alignItems: "center",
//                       marginTop: "80px",
//                       boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
//                       padding: "20px",
//                     }}
//                   >
//                     <div
//                       className="card-title"
//                       style={{ marginBottom: "20px" }}
//                     >
//                       {mainData?.productLifecycleJourney?.chainOfCustody.name}
//                     </div>
//                     <div
//                       className="pill"
//                       style={{
//                         borderColor: "#A78BFA",
//                         color: "#A78BFA",
//                         marginBottom: "10px",
//                       }}
//                     >
//                       {mainData?.productLifecycleJourney?.chainOfCustody.status}
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </>
//           )}

//           {viewDurability && (
//             <>
//               {mainData?.productLifecycleJourney?.durabilityAndLifespan
//                 .orderNumber == "n/a" ||
//                 mainData?.productLifecycleJourney?.durabilityAndLifespan
//                   .orderNumber == "" ? (
//                 <div
//                   className="step"
//                   style={{ cursor: "default" }}
//                   role="listitem"
//                   aria-label={`Step ${mainData?.productLifecycleJourney?.durabilityAndLifespan?.dppId}: ${mainData?.productLifecycleJourney?.durabilityAndLifespan?.dppId}`}
//                 >
//                   <div className="icon-wrap" style={{ marginBottom: "10px" }}>
//                     <div
//                       className="icon-circle "
//                       style={{
//                         background: "grey",
//                       }}
//                     >
//                       <svg
//                         width="36"
//                         height="36"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="#fff"
//                         strokeWidth="1.6"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       >
//                         <ShieldIcon color="white" />
//                       </svg>
//                     </div>
//                   </div>

//                   <div
//                     className="timeline-line"
//                     style={{ marginTop: "80px" }}
//                   />
//                   <div className="hl-connector"></div>
//                   <div
//                     className="card "
//                     style={{
//                       display: "flex",
//                       flexDirection: "column",
//                       alignItems: "center",
//                       marginTop: "80px",
//                       boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
//                       padding: "20px",
//                     }}
//                   >
//                     <div
//                       className="card-title"
//                       style={{ marginBottom: "20px" }}
//                     >
//                       {
//                         mainData?.productLifecycleJourney?.durabilityAndLifespan
//                           .name
//                       }
//                     </div>
//                     <div
//                       className="pill"
//                       style={{
//                         borderColor: "#A78BFA",
//                         color: "#A78BFA",
//                         marginBottom: "10px",
//                       }}
//                     >
//                       Not Available
//                     </div>
//                   </div>
//                 </div>
//               ) : (
//                 <div
//                   className="step"
//                   onClick={() => openStepForDurability()}
//                   style={{ cursor: "pointer" }}
//                   role="listitem"
//                   aria-label={`Step ${mainData?.productLifecycleJourney?.durabilityAndLifespan?.dppId}: ${mainData?.productLifecycleJourney?.durabilityAndLifespan?.dppId}`}
//                 >
//                   <div className="icon-wrap" style={{ marginBottom: "10px" }}>
//                     <div
//                       className="icon-circle timeline-icon"
//                       style={{
//                         background: "#A78BFA",
//                       }}
//                     >
//                       <svg
//                         width="36"
//                         height="36"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="#fff"
//                         strokeWidth="1.6"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       >
//                         <ShieldIcon color="white" />
//                       </svg>
//                     </div>
//                     <div className="step-number">
//                       {
//                         mainData?.productLifecycleJourney?.durabilityAndLifespan
//                           .orderNumber
//                       }
//                     </div>
//                   </div>

//                   <div
//                     className="timeline-line"
//                     style={{ marginTop: "80px" }}
//                   />
//                   <div className="hl-connector"></div>
//                   <div
//                     className="card timeline-icon2"
//                     style={{
//                       display: "flex",
//                       flexDirection: "column",
//                       alignItems: "center",
//                       marginTop: "80px",
//                       boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
//                       padding: "20px",
//                     }}
//                   >
//                     <div
//                       className="card-title"
//                       style={{ marginBottom: "20px" }}
//                     >
//                       {
//                         mainData?.productLifecycleJourney?.durabilityAndLifespan
//                           .name
//                       }
//                     </div>
//                     <div
//                       className="pill"
//                       style={{
//                         borderColor: "#A78BFA",
//                         color: "#A78BFA",
//                         marginBottom: "10px",
//                       }}
//                     >
//                       {
//                         mainData?.productLifecycleJourney?.durabilityAndLifespan
//                           .status
//                       }
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </>
//           )}

//           {viewRepairValue && (
//             <>
//               {mainData?.productLifecycleJourney?.returnRepairInfo
//                 .orderNumber == "n/a" ||
//                 mainData?.productLifecycleJourney?.returnRepairInfo.orderNumber ==
//                 "" ? (
//                 <div
//                   className="step"
//                   style={{ cursor: "default" }}
//                   role="listitem"
//                   aria-label={`Step ${mainData?.productLifecycleJourney?.returnRepairInfo?.dppId}: ${mainData?.productLifecycleJourney?.returnRepairInfo?.dppId}`}
//                 >
//                   <div className="icon-wrap" style={{ marginBottom: "10px" }}>
//                     <div
//                       className="icon-circle "
//                       style={{
//                         background: "grey",
//                       }}
//                     >
//                       <svg
//                         width="36"
//                         height="36"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="#fff"
//                         strokeWidth="1.6"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       >
//                         <BuildIcon color="white" />
//                       </svg>
//                     </div>
//                   </div>

//                   <div
//                     className="timeline-line"
//                     style={{ marginTop: "80px" }}
//                   />
//                   <div className="hl-connector"></div>
//                   <div
//                     className="card "
//                     style={{
//                       display: "flex",
//                       flexDirection: "column",
//                       alignItems: "center",
//                       marginTop: "80px",
//                       boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
//                       padding: "20px",
//                     }}
//                   >
//                     <div
//                       className="card-title"
//                       style={{ marginBottom: "20px" }}
//                     >
//                       {mainData?.productLifecycleJourney?.returnRepairInfo.name}
//                     </div>
//                     <div
//                       className="pill"
//                       style={{
//                         borderColor: "#A78BFA",
//                         color: "#A78BFA",
//                         marginBottom: "10px",
//                       }}
//                     >
//                       Not Available
//                     </div>
//                   </div>
//                 </div>
//               ) : (
//                 <div
//                   className="step"
//                   onClick={() => openStepForRCV()}
//                   style={{ cursor: "pointer" }}
//                   role="listitem"
//                   aria-label={`Step ${mainData?.productLifecycleJourney?.returnRepairInfo?.dppId}: ${mainData?.productLifecycleJourney?.returnRepairInfo?.dppId}`}
//                 >
//                   <div className="icon-wrap" style={{ marginBottom: "10px" }}>
//                     <div
//                       className="icon-circle timeline-icon"
//                       style={{
//                         background: "#60A5FA",
//                       }}
//                     >
//                       <svg
//                         width="36"
//                         height="36"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="#fff"
//                         strokeWidth="1.6"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       >
//                         <BuildIcon color="white" />
//                       </svg>
//                     </div>
//                     <div className="step-number">
//                       {
//                         mainData?.productLifecycleJourney?.returnRepairInfo
//                           .orderNumber
//                       }
//                     </div>
//                   </div>

//                   <div
//                     className="timeline-line"
//                     style={{ marginTop: "80px" }}
//                   />
//                   <div className="hl-connector"></div>
//                   <div
//                     className="card timeline-icon2"
//                     style={{
//                       display: "flex",
//                       flexDirection: "column",
//                       alignItems: "center",
//                       marginTop: "80px",
//                       boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
//                       padding: "20px",
//                     }}
//                   >
//                     <div
//                       className="card-title"
//                       style={{ marginBottom: "20px" }}
//                     >
//                       {mainData?.productLifecycleJourney?.returnRepairInfo.name}
//                     </div>
//                     <div
//                       className="pill"
//                       style={{
//                         borderColor: "#A78BFA",
//                         color: "#A78BFA",
//                         marginBottom: "10px",
//                       }}
//                     >
//                       {
//                         mainData?.productLifecycleJourney?.returnRepairInfo
//                           .status
//                       }
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </>
//           )}

//           {viewPackaging && (
//             <>
//               {mainData?.productLifecycleJourney?.packagingWasteManagement
//                 .orderNumber == "n/a" ||
//                 mainData?.productLifecycleJourney?.packagingWasteManagement
//                   .orderNumber == "" ? (
//                 <div
//                   className="step"
//                   style={{ cursor: "default" }}
//                   role="listitem"
//                   aria-label={`Step ${mainData?.productLifecycleJourney?.packagingWasteManagement?.dppId}: ${mainData?.productLifecycleJourney?.packagingWasteManagement?.dppId}`}
//                 >
//                   <div className="icon-wrap" style={{ marginBottom: "10px" }}>
//                     <div
//                       className="icon-circle "
//                       style={{
//                         background: "grey",
//                       }}
//                     >
//                       <svg
//                         width="36"
//                         height="36"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="#fff"
//                         strokeWidth="1.6"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       >
//                         <FactoryIcon color="white" />
//                       </svg>
//                     </div>
//                   </div>

//                   <div
//                     className="timeline-line"
//                     style={{ marginTop: "80px" }}
//                   />
//                   <div className="hl-connector"></div>
//                   <div
//                     className="card"
//                     style={{
//                       display: "flex",
//                       flexDirection: "column",
//                       alignItems: "center",
//                       marginTop: "80px",
//                       boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
//                       padding: "20px",
//                     }}
//                   >
//                     <div
//                       className="card-title"
//                       style={{ marginBottom: "20px" }}
//                     >
//                       {
//                         mainData?.productLifecycleJourney
//                           ?.packagingWasteManagement.name
//                       }
//                     </div>
//                     <div
//                       className="pill"
//                       style={{
//                         borderColor: "#A78BFA",
//                         color: "#A78BFA",
//                         marginBottom: "10px",
//                       }}
//                     >
//                       Not Available
//                     </div>
//                   </div>
//                 </div>
//               ) : (
//                 <div
//                   className="step"
//                   onClick={() => openStepForPWM()}
//                   style={{ cursor: "pointer" }}
//                   role="listitem"
//                   aria-label={`Step ${mainData?.productLifecycleJourney?.packagingWasteManagement?.dppId}: ${mainData?.productLifecycleJourney?.packagingWasteManagement?.dppId}`}
//                 >
//                   <div className="icon-wrap" style={{ marginBottom: "10px" }}>
//                     <div
//                       className="icon-circle timeline-icon"
//                       style={{
//                         background: "#FF69B4",
//                       }}
//                     >
//                       <svg
//                         width="36"
//                         height="36"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="#fff"
//                         strokeWidth="1.6"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       >
//                         <FactoryIcon color="white" />
//                       </svg>
//                     </div>
//                     <div className="step-number">
//                       {
//                         mainData?.productLifecycleJourney
//                           ?.packagingWasteManagement.orderNumber
//                       }
//                     </div>
//                   </div>

//                   <div
//                     className="timeline-line"
//                     style={{ marginTop: "80px" }}
//                   />
//                   <div className="hl-connector"></div>
//                   <div
//                     className="card timeline-icon2"
//                     style={{
//                       display: "flex",
//                       flexDirection: "column",
//                       alignItems: "center",
//                       marginTop: "80px",
//                       boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
//                       padding: "20px",
//                     }}
//                   >
//                     <div
//                       className="card-title"
//                       style={{ marginBottom: "20px" }}
//                     >
//                       {
//                         mainData?.productLifecycleJourney
//                           ?.packagingWasteManagement.name
//                       }
//                     </div>
//                     <div
//                       className="pill"
//                       style={{
//                         borderColor: "#A78BFA",
//                         color: "#A78BFA",
//                         marginBottom: "10px",
//                       }}
//                     >
//                       {
//                         mainData?.productLifecycleJourney
//                           ?.packagingWasteManagement.status
//                       }
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </>
//           )}

//           {viewSocialCompliance && (
//             <>
//               {mainData?.productLifecycleJourney?.socialCompliance
//                 .orderNumber == "n/a" ||
//                 mainData?.productLifecycleJourney?.socialCompliance.orderNumber ==
//                 "" ? (
//                 <div
//                   className="step"
//                   style={{ cursor: "default" }}
//                   role="listitem"
//                   aria-label={`Step ${mainData?.productLifecycleJourney?.socialCompliance?.dppId}: ${mainData?.productLifecycleJourney?.socialCompliance?.dppId}`}
//                 >
//                   <div className="icon-wrap" style={{ marginBottom: "10px" }}>
//                     <div
//                       className="icon-circle "
//                       style={{
//                         background: "grey",
//                       }}
//                     >
//                       <svg
//                         width="36"
//                         height="36"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="#fff"
//                         strokeWidth="1.6"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       >
//                         <EnergySavingsLeafIcon color="white" />
//                       </svg>
//                     </div>
//                   </div>

//                   <div
//                     className="timeline-line"
//                     style={{ marginTop: "80px" }}
//                   />
//                   <div className="hl-connector"></div>
//                   <div
//                     className="card "
//                     style={{
//                       display: "flex",
//                       flexDirection: "column",
//                       alignItems: "center",
//                       marginTop: "80px",
//                       boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
//                       padding: "20px",
//                     }}
//                   >
//                     <div
//                       className="card-title"
//                       style={{ marginBottom: "20px" }}
//                     >
//                       {mainData?.productLifecycleJourney?.socialCompliance.name}
//                     </div>
//                     <div
//                       className="pill"
//                       style={{
//                         borderColor: "#A78BFA",
//                         color: "#A78BFA",
//                         marginBottom: "10px",
//                       }}
//                     >
//                       Not Available
//                     </div>
//                   </div>
//                 </div>
//               ) : (
//                 <div
//                   className="step"
//                   onClick={() => openStepForEvt()}
//                   style={{ cursor: "pointer" }}
//                   role="listitem"
//                   aria-label={`Step ${mainData?.productLifecycleJourney?.socialCompliance?.dppId}: ${mainData?.productLifecycleJourney?.socialCompliance?.dppId}`}
//                 >
//                   <div className="icon-wrap" style={{ marginBottom: "10px" }}>
//                     <div
//                       className="icon-circle timeline-icon"
//                       style={{
//                         background:
//                           mainData?.productLifecycleJourney?.socialCompliance
//                             ?.badgeColor,
//                       }}
//                     >
//                       <svg
//                         width="36"
//                         height="36"
//                         viewBox="0 0 24 24"
//                         fill="none"
//                         stroke="#fff"
//                         strokeWidth="1.6"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       >
//                         <EnergySavingsLeafIcon color="white" />
//                       </svg>
//                     </div>
//                     <div className="step-number">
//                       {
//                         mainData?.productLifecycleJourney?.socialCompliance
//                           .orderNumber
//                       }
//                     </div>
//                   </div>

//                   <div
//                     className="timeline-line"
//                     style={{ marginTop: "80px" }}
//                   />
//                   <div className="hl-connector"></div>
//                   <div
//                     className="card timeline-icon2"
//                     style={{
//                       display: "flex",
//                       flexDirection: "column",
//                       alignItems: "center",
//                       marginTop: "80px",
//                       boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
//                       padding: "20px",
//                     }}
//                   >
//                     <div
//                       className="card-title"
//                       style={{ marginBottom: "20px" }}
//                     >
//                       {mainData?.productLifecycleJourney?.socialCompliance.name}
//                     </div>
//                     <div
//                       className="pill"
//                       style={{
//                         borderColor: "#A78BFA",
//                         color: "#A78BFA",
//                         marginBottom: "10px",
//                       }}
//                     >
//                       {mainData?.productLifecycleJourney?.socialCompliance
//                         .status
//                         ? mainData?.productLifecycleJourney?.socialCompliance
//                           .status
//                         : "-"}
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </>
//           )}
//         </div>

//         <div
//           className="desktop-dots"
//           role="tablist"
//           aria-label="Timeline pagination"
//         >
//           {steps.map((_, i) => (
//             <button
//               key={`dot-${i}`}
//               type="button"
//               className={`desktop-dot ${activeIndex === i ? "active" : ""}`}
//               aria-label={`Go to slide ${i + 1}`}
//               aria-current={activeIndex === i ? "true" : "false"}
//               onClick={() => scrollToIndex(i)}
//             />
//           ))}
//         </div>
//       </div>
//     </>
//   );
// };

// const mapStateToProps = (state) => {
//   return {
//     getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
//   };
// };

// const mapDispatchToProps = (dispatch) => {
//   return {
//     getSubModulesByRoleId: (roleId, jwtToken) =>
//       dispatch(getSubModulesByRoleId(roleId, jwtToken)),
//   };
// };

// export default connect(
//   mapStateToProps,
//   mapDispatchToProps,
// )(DesktopTimelineSlider);


import React, { useEffect, useRef, useState } from "react";
import BuildIcon from "@mui/icons-material/Build";
import EnergySavingsLeafIcon from "@mui/icons-material/EnergySavingsLeaf";
import ArticleIcon from "@mui/icons-material/Article";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import ShieldIcon from "@mui/icons-material/Shield";
import FactoryIcon from "@mui/icons-material/Factory";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import CategoryIcon from "@mui/icons-material/Category";
import { Science } from "@mui/icons-material";
import { getSubModulesByRoleId } from "store";
import Cookies from "universal-cookie";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";

const cookies = new Cookies();

const DesktopTimelineSlider = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  steps,
  openStep,
  openStepForTechnicalDocuments,
  openStepForDurability,
  openStepForRawMaterial,
  openStepForPWM,
  openStepForEvt,
  openStepForCOC,
  openStepForManufacturing,
  openStepForRCV,
  openStepForProductTests,
  mainData,
}) => {
  const trackRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);



  // Sync dots with current snap
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    let rafId;
    const onScroll = () => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        const first = track.querySelector(".step");
        const gap = 24; // keep in sync with CSS
        if (first) {
          const cardW = first.offsetWidth + gap;
          const idx = Math.round(track.scrollLeft / cardW);
          setActiveIndex(Math.max(0, Math.min(steps?.length - 1, idx)));
        }
      });
    };

    track.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      track.removeEventListener("scroll", onScroll);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, [steps?.length]);

  const scrollToIndex = (index) => {
    const track = trackRef.current;
    if (!track) return;
    const first = track.querySelector(".step");
    const gap = 24;
    const clamped = Math.max(0, Math.min(steps?.length - 1, index));
    const delta = first ? clamped * (first.offsetWidth + gap) : clamped * 360;
    track.scrollTo({ left: delta, behavior: "smooth" });
    setActiveIndex(clamped);
  };

  // const scrollByOne = (dir) => scrollToIndex(activeIndex + dir);
  // let loginDetails = cookies.get("loginDetailsForWMS");

  // let jwtToken = loginDetails?.jwt;

  // let roleId = loginDetails?.data?.roleId;
  // useEffect(() => {
  //   getSubModulesByRoleId(roleId, jwtToken);
  // }, [roleId]);

  // const [modulesData, setModulesData] = useState([]);

  // useEffect(() => {
  //   setModulesData(
  //     getSubModulesByRoleIdReducer.subModulesByRoleData.data
  //       ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
  //       : [],
  //   );
  // }, [getSubModulesByRoleIdReducer]);

  // let packagingModule = modulesData.find(
  //   (moduleId) => moduleId.moduleId == "7e02c688-4e21-4805-9f51-2320dda92382",
  // );

  // let viewPackaging = packagingModule
  //   ? packagingModule.actionId.includes("825e65a6-0f01-4fe7-91a1-63cb571b093a")
  //   : null;

  // let productTestingModule = modulesData.find(
  //   (moduleId) => moduleId.moduleId == "16cc0217-cbce-4e3f-874b-89b3fbdd0232",
  // );

  // let viewProductTesting = productTestingModule
  //   ? productTestingModule.actionId.includes(
  //       "896c7b19-7fe5-4306-9f06-2735e57a7b84",
  //     )
  //   : null;

  // let durabilityModule = modulesData.find(
  //   (moduleId) => moduleId.moduleId == "5e690abe-d7a1-4e45-8782-43409b4edab2",
  // );

  // let viewDurability = durabilityModule
  //   ? durabilityModule.actionId.includes("24059d11-ee70-4a0d-a132-56bf7195de49")
  //   : null;

  // let cocModule = modulesData.find(
  //   (moduleId) => moduleId.moduleId == "269b317f-3fc3-4ce8-b885-0817acf36a66",
  // );

  // let viewCoc = cocModule
  //   ? cocModule.actionId.includes("1f130e9a-11bf-4ad3-b690-4fcefedfbb44")
  //   : null;

  // let rmModule = modulesData.find(
  //   (moduleId) => moduleId.moduleId == "852fd581-2cd9-40d1-b0f6-e29dd61566ff",
  // );

  // let viewRm = rmModule
  //   ? rmModule.actionId.includes("94e1aedf-8637-4d27-9079-2812f320e458")
  //   : null;

  // let repairValueModule = modulesData.find(
  //   (moduleId) => moduleId.moduleId == "9f3b7cf0-eb97-4567-8d4a-711868269662",
  // );

  // let viewRepairValue = repairValueModule
  //   ? repairValueModule.actionId.includes(
  //       "a0f6b96e-282c-4349-b655-f08f172739f8",
  //     )
  //   : null;

  // let manufacturingModule = modulesData.find(
  //   (moduleId) => moduleId.moduleId == "d51e5caa-b714-4739-877a-3b78d6f9d263",
  // );

  // let viewManufacturing = manufacturingModule
  //   ? manufacturingModule.actionId.includes(
  //       "6fd9218e-53e3-49ec-85bc-ef986f9ede86",
  //     )
  //   : null;

  // let validationModule = modulesData.find(
  //   (moduleId) => moduleId.moduleId == "b3605909-30dc-4c9f-8918-f1ef34354fd2",
  // );

  // let viewValidation = validationModule
  //   ? validationModule.actionId.includes("acf6e194-8a3f-4c7f-98b7-9cc2151ed763")
  //   : null;

  // let socialComplianceModule = modulesData.find(
  //   (moduleId) => moduleId.moduleId == "013a3276-d1db-4051-b489-b199b4710cf4",
  // );

  // let viewSocialCompliance = socialComplianceModule
  //   ? socialComplianceModule.actionId.includes(
  //       "3dce3a16-274c-4937-92cc-df13fa7c6c8d",
  //     )
  //   : null;




  const { pathname, search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const urlDppId = queryParams.get("dppId") || queryParams.get("dppid");
  const urlDppCode = queryParams.get("dppCode") || queryParams.get("dppcode");

  const hasDppId = Boolean(urlDppId || urlDppCode);

  const isFromQRCode = (pathname.toLowerCase() === "/dpp") && hasDppId;


  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);


  let packagingModule = modulesData?.find(
    (moduleId) => moduleId.moduleId == "7e02c688-4e21-4805-9f51-2320dda92382",
  );
  let viewPackaging = isFromQRCode
    ? true
    : packagingModule
      ? packagingModule.actionId.includes("825e65a6-0f01-4fe7-91a1-63cb571b093a")
      : null;

  let productTestingModule = modulesData?.find(
    (moduleId) => moduleId.moduleId == "16cc0217-cbce-4e3f-874b-89b3fbdd0232",
  );
  let viewProductTesting = isFromQRCode
    ? true
    : productTestingModule
      ? productTestingModule.actionId.includes("896c7b19-7fe5-4306-9f06-2735e57a7b84")
      : null;

  let durabilityModule = modulesData?.find(
    (moduleId) => moduleId.moduleId == "5e690abe-d7a1-4e45-8782-43409b4edab2",
  );
  let viewDurability = isFromQRCode
    ? true
    : durabilityModule
      ? durabilityModule.actionId.includes("24059d11-ee70-4a0d-a132-56bf7195de49")
      : null;

  let cocModule = modulesData?.find(
    (moduleId) => moduleId.moduleId == "269b317f-3fc3-4ce8-b885-0817acf36a66",
  );
  let viewCoc = isFromQRCode
    ? true
    : cocModule
      ? cocModule.actionId.includes("1f130e9a-11bf-4ad3-b690-4fcefedfbb44")
      : null;

  let rmModule = modulesData?.find(
    (moduleId) => moduleId.moduleId == "852fd581-2cd9-40d1-b0f6-e29dd61566ff",
  );
  let viewRm = isFromQRCode
    ? true
    : rmModule
      ? rmModule.actionId.includes("94e1aedf-8637-4d27-9079-2812f320e458")
      : null;

  let repairValueModule = modulesData?.find(
    (moduleId) => moduleId.moduleId == "9f3b7cf0-eb97-4567-8d4a-711868269662",
  );
  let viewRepairValue = isFromQRCode
    ? true
    : repairValueModule
      ? repairValueModule.actionId.includes("a0f6b96e-282c-4349-b655-f08f172739f8")
      : null;

  let manufacturingModule = modulesData?.find(
    (moduleId) => moduleId.moduleId == "d51e5caa-b714-4739-877a-3b78d6f9d263",
  );
  let viewManufacturing = isFromQRCode
    ? true
    : manufacturingModule
      ? manufacturingModule.actionId.includes("6fd9218e-53e3-49ec-85bc-ef986f9ede86")
      : null;

  let validationModule = modulesData?.find(
    (moduleId) => moduleId.moduleId == "b3605909-30dc-4c9f-8918-f1ef34354fd2",
  );
  let viewValidation = isFromQRCode
    ? true
    : validationModule
      ? validationModule.actionId.includes("acf6e194-8a3f-4c7f-98b7-9cc2151ed763")
      : null;

  let socialComplianceModule = modulesData?.find(
    (moduleId) => moduleId.moduleId == "013a3276-d1db-4051-b489-b199b4710cf4",
  );
  let viewSocialCompliance = isFromQRCode
    ? true
    : socialComplianceModule
      ? socialComplianceModule.actionId.includes("3dce3a16-274c-4937-92cc-df13fa7c6c8d")
      : null;


  return (
    <>
      <style>{`
        /* DESKTOP slider styles */
        @media (min-width: 901px) {
          .desktop-slider {
            display: grid;
            grid-template-rows: auto auto auto;
            gap: 12px;
            margin-top: -20px
          }
          .desktop-controls {
            display: flex; justify-content: space-between; align-items: center;
            gap: 8px; padding: 0 6px;
          }
          .desktop-btn {
            display: inline-flex; align-items: center; justify-content: center;
            width: 38px; height: 38px; border-radius: 50%; border: none;
            background: #f5f5f5; color: #0f172a; cursor: pointer;
            box-shadow: 0 8px 20px rgba(2,6,23,0.06);
          }
          .desktop-btn:disabled { opacity: 0.45; cursor: not-allowed; }

          .desktop-track {
            display: flex;
            gap: 24px;
            overflow-x: auto;
            padding: 10px 6px;
            scroll-snap-type: x mandatory;
            -webkit-overflow-scrolling: touch;
          }
          .desktop-track::-webkit-scrollbar { height: 10px; }
          .desktop-track::-webkit-scrollbar-thumb {
            background: rgba(2,6,23,0.16); border-radius: 999px;
          }

          .desktop-track .step {
            scroll-snap-align: start;
            min-width: 360px; 
            flex-shrink: 0;
          }

          .desktop-dots {
            display: flex; align-items: center; justify-content: center;
            gap: 8px; padding-bottom: 6px;
          }
          .desktop-dot {
            width: 9px; height: 9px; border-radius: 50%;
            background: rgba(2,6,23,0.18); border: none; cursor: pointer;
          }
          .desktop-dot.active { background: #0f172a; }
        }
      `}</style>

      {/* Note: I removed the toxic <style> block that had .steps { display: none } */}

      <style>{`
        .plg-container {
            font-family: Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
            background: "white" ;
            border: 1px solid rgba(59,130,246,0.08);
            border-radius: 12px;
            padding: 20px;
            box-shadow: 0 6px 18px rgba(2,6,23,0.06);
        }
        .plg-header h3 { margin: 0; font-size: 18px; color: #0f172a; }
        .plg-header small { color: #6b7280; }

        .timeline-wrap { position: relative; margin-top: 20px; padding: 36px 12px 20px; background: transparent; }
        .timeline-line {
            position: absolute;
            left: 48px;
            right: 48px;
            top: 72px;
            height: 6px;
            background: linear-gradient(90deg,#bbdefb,#c8f7e6);
            border-radius: 4px;
            filter: blur(0.2px);
        }

        .hl-connector {
          width: 2px;
          height: 82px;      
          margin-top: 32px;
          margin-bottom: -82px;    
          background: rgba(16, 185, 129, 0.30);
        }       
        .steps {
            display: flex;
            gap: 40px;
            align-items: flex-start;
            justify-content: space-between;
            position: relative;
        }
        .step {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 300px;
            min-width: 170px;
            z-index: 999;
        }

        .icon-wrap { position: relative; margin-bottom: 12px; }
        .icon-circle {
            width: 86px;
            height: 86px;
            border-radius: 50%;
            background: linear-gradient(180deg,#05b85b,#00b74a);
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 6px 20px rgba(3,102,67,0.12), inset 0 4px 0 rgba(255,255,255,0.12);
        }
        .icon-circle svg { display: block; }

        .step-number {
            position: absolute;
            top: -8px;
            right: -8px;
            width: 28px;
            height: 28px;
            border-radius: 50%;
            background: #fff;
            border: 3px solid rgba(99,102,241,0.8);
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 600;
            color: #374151;
            box-shadow: 0 4px 10px rgba(2,6,23,0.08);
        }

        .card {
            margin-top: 12px;
            background: #fff;
            width: fit-content;
            border-radius: 10px;
            padding: 6px 12px;
            box-shadow: 0 8px 20px rgba(2,6,23,0.04);
            text-align: center;
        }
        .card-title { color: #0f172a; font-weight: 600; margin-bottom: -5px; font-size: 14px; width: fit-content; margin-left: auto; margin-right: auto; }
        .pill {
            display: inline-block;
            padding: 5px;
            border-radius: 5px;
            font-size: 12px;
            border: 2px solid;
            background: rgba(255,255,255,0.98);
            font-weight: 600;
        }

        /* responsive */
        // @media (max-width: 900px) {
        //     .steps { gap: 24px; overflow-x: auto; padding-bottom: 8px; }
        //     .timeline-line { left: 16px; right: 16px; top: 116px; }
        // }

        /* MOBILE FIX: Icons aur cards ka size shrink kar diya gaya hai taaki UI na faile */
       /* MOBILE FIX: Perfect Alignment & Sizes */
       /* MOBILE FIX: Locked Parent Width + Horizontal Scroller */
        @media (max-width: 900px) { 
          .desktop-slider { 
            display: block !important; 
            width: 100% !important;
            max-width: 100vw !important;
            margin-top: 0px !important;
            box-sizing: border-box !important;
            overflow: hidden !important;  
          }
           
          .desktop-track {
            display: flex !important;
            flex-wrap: nowrap !important;  
            overflow-x: auto !important; 
            gap: 10px !important; 
            padding: 20px 5px 30px 5px !important; 
            -webkit-overflow-scrolling: touch;  
            scroll-snap-type: x mandatory;
            width: 100% !important;
            box-sizing: border-box !important;
          }
          
          /* 3. Har ek step ki fixed width taaki wo pichke nahi */
          .desktop-track .step {
            flex: 0 0 150px !important;  
            max-width: 150px !important;
            scroll-snap-align: start;
            position: relative !important; 
            box-sizing: border-box !important;
          }
          
          /* Horizontal Connecting Line */
          .timeline-line {
            position: absolute !important;
            top: 23px !important; 
            left: 50% !important; 
            width: 100% !important; 
            height: 3px !important;
            margin-top: 0 !important; 
            z-index: 1 !important; 
            background: linear-gradient(90deg,#bbdefb,#c8f7e6) !important;
            display: block !important;
          }
          .step:last-child .timeline-line {
            display: none !important; /* Last item ke aage line nahi jayegi */
          }
          
          /* Gol Icons */
          .icon-wrap { margin-bottom: 0px !important; }
          .icon-circle {
            width: 46px !important; 
            height: 46px !important;
            margin: 0 auto !important;
            z-index: 2 !important; 
            position: relative;
          }
          .icon-circle svg { width: 22px !important; height: 22px !important; }
          
          /* Badge (1, 2, 3) */
          .step-number {
            width: 20px !important; height: 20px !important; font-size: 11px !important;
            top: -2px !important; right: -2px !important; z-index: 3 !important;
          }
          
          /* Vertical Connector */
          .hl-connector {
            height: 20px !important; width: 2px !important; margin: 5px auto 0 auto !important;
            background: rgba(16, 185, 129, 0.4) !important; display: block !important;
          }
          
          /* Cards */
          .card {
            padding: 10px !important; 
            margin: 0 auto !important; 
            width: 100% !important;
            box-sizing: border-box !important;
            min-height: 85px !important; 
            display: flex !important;
            flex-direction: column !important;
            justify-content: center !important;
          }
          .card-title {
            font-size: 12px !important; margin-bottom: 8px !important;
            white-space: normal !important; word-wrap: break-word !important; line-height: 1.3 !important;
          }
          .pill { font-size: 10px !important; padding: 4px 8px !important; }

          .desktop-controls, .desktop-dots { display: none !important; }
        }
      `}</style>

      <div
        className="desktop-slider"
        aria-label="Desktop timeline slider"
        style={{ marginTop: "20px" }}
      >
        <div className="desktop-track" ref={trackRef} role="list">
          {viewManufacturing && (
            <>
              {!mainData?.productLifecycleJourney?.manufacturer.orderNumber ||
                mainData?.productLifecycleJourney?.manufacturer.orderNumber ==
                "n/a" ||
                mainData?.productLifecycleJourney?.manufacturer.orderNumber ==
                "" ? (
                <div
                  className="step"
                  style={{ cursor: "default" }}
                  role="listitem"
                  aria-label={`Step ${mainData?.productLifecycleJourney?.manufacturer?.dppId}: ${mainData?.productLifecycleJourney?.manufacturer?.dppId}`}
                >
                  <div className="icon-wrap" style={{ marginBottom: "10px" }}>
                    <div
                      className="icon-circle "
                      style={{
                        background: "grey",
                      }}
                    >
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#fff"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <Inventory2Icon color="white" />
                      </svg>
                    </div>
                  </div>

                  <div
                    className="timeline-line"
                    style={{ marginTop: "80px" }}
                  />
                  <div className="hl-connector"></div>
                  <div
                    className="card "
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "80px",
                      boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
                      padding: "20px",
                    }}
                  >
                    <div
                      className="card-title"
                      style={{ marginBottom: "20px" }}
                    >
                      {mainData?.productLifecycleJourney?.manufacturer.name}
                    </div>
                    <div
                      className="pill"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      Not Available
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className="step"
                  onClick={() => openStepForManufacturing()}
                  style={{ cursor: "pointer" }}
                  role="listitem"
                  aria-label={`Step ${mainData?.productLifecycleJourney?.manufacturer?.dppId}: ${mainData?.productLifecycleJourney?.manufacturer?.dppId}`}
                >
                  <div className="icon-wrap" style={{ marginBottom: "10px" }}>
                    <div
                      className="icon-circle timeline-icon"
                      style={{
                        background: "#FF5F15",
                      }}
                    >
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#fff"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <Inventory2Icon color="white" />
                      </svg>
                    </div>
                    <div className="step-number">
                      {
                        mainData?.productLifecycleJourney?.manufacturer
                          .orderNumber
                      }
                    </div>
                  </div>

                  <div
                    className="timeline-line"
                    style={{ marginTop: "80px" }}
                  />
                  <div className="hl-connector"></div>
                  <div
                    className="card timeline-icon2"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "80px",
                      boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
                      padding: "20px",
                    }}
                  >
                    <div
                      className="card-title"
                      style={{ marginBottom: "20px" }}
                    >
                      {mainData?.productLifecycleJourney?.manufacturer.name}
                    </div>
                    <div
                      className="pill"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                      }}
                    >
                      {mainData?.productLifecycleJourney?.manufacturer.status
                        ? mainData?.productLifecycleJourney?.manufacturer.status
                        : "-"}
                    </div>
                  </div>
                </div>
              )}
            </>
          )}

          {viewRm && (
            <>
              {!mainData?.productLifecycleJourney?.rmTraceability.orderNumber ||
                mainData?.productLifecycleJourney?.rmTraceability.orderNumber ==
                "n/a" ||
                mainData?.productLifecycleJourney?.rmTraceability.orderNumber ==
                "" ? (
                <div
                  className="step"
                  style={{ cursor: "default" }}
                  role="listitem"
                  aria-label={`Step ${mainData?.productLifecycleJourney?.rmTraceability?.dppId}: ${mainData?.productLifecycleJourney?.rmTraceability?.dppId}`}
                >
                  <div className="icon-wrap" style={{ marginBottom: "10px" }}>
                    <div
                      className="icon-circle "
                      style={{
                        background: "grey",
                      }}
                    >
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#fff"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <CategoryIcon color="white" />
                      </svg>
                    </div>
                  </div>

                  <div
                    className="timeline-line"
                    style={{ marginTop: "80px" }}
                  />
                  <div className="hl-connector"></div>
                  <div
                    className="card "
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "80px",
                      boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
                      padding: "20px",
                    }}
                  >
                    <div
                      className="card-title"
                      style={{ marginBottom: "20px" }}
                    >
                      {mainData?.productLifecycleJourney?.rmTraceability.name}
                    </div>
                    <div
                      className="pill"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                      }}
                    >
                      Not Available
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className="step"
                  onClick={() => openStepForRawMaterial()}
                  style={{ cursor: "pointer" }}
                  role="listitem"
                  aria-label={`Step ${mainData?.productLifecycleJourney?.rmTraceability?.dppId}: ${mainData?.productLifecycleJourney?.rmTraceability?.dppId}`}
                >
                  <div className="icon-wrap" style={{ marginBottom: "10px" }}>
                    <div
                      className="icon-circle timeline-icon"
                      style={{
                        background: "#0000FF",
                      }}
                    >
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#fff"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <CategoryIcon color="white" />
                      </svg>
                    </div>
                    <div className="step-number">
                      {
                        mainData?.productLifecycleJourney?.rmTraceability
                          .orderNumber
                      }
                    </div>
                  </div>

                  <div
                    className="timeline-line"
                    style={{ marginTop: "80px" }}
                  />
                  <div className="hl-connector"></div>
                  <div
                    className="card timeline-icon2"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "80px",
                      boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
                      padding: "20px",
                    }}
                  >
                    <div
                      className="card-title"
                      style={{ marginBottom: "20px" }}
                    >
                      {mainData?.productLifecycleJourney?.rmTraceability.name}
                    </div>
                    <div
                      className="pill"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                      }}
                    >
                      {mainData?.productLifecycleJourney?.rmTraceability.status
                        ? mainData?.productLifecycleJourney?.rmTraceability
                          .status
                        : "-"}
                    </div>
                  </div>
                </div>
              )}
            </>
          )}

          {viewProductTesting && (
            <>
              {mainData?.productLifecycleJourney?.productTests.orderNumber ==
                "n/a" ||
                mainData?.productLifecycleJourney?.productTests.orderNumber ==
                "" ? (
                <div
                  className="step"
                  style={{ cursor: "default" }}
                  role="listitem"
                  aria-label={`Step ${mainData?.productLifecycleJourney?.productTests?.dppId}: ${mainData?.productLifecycleJourney?.productTests?.dppId}`}
                >
                  <div className="icon-wrap" style={{ marginBottom: "10px" }}>
                    <div
                      className="icon-circle "
                      style={{
                        background: "grey",
                      }}
                    >
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#fff"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <Science color="white" />
                      </svg>
                    </div>
                  </div>

                  <div
                    className="timeline-line"
                    style={{ marginTop: "80px" }}
                  />
                  <div className="hl-connector"></div>
                  <div
                    className="card "
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "80px",
                      boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
                      padding: "20px",
                    }}
                  >
                    <div
                      className="card-title"
                      style={{ marginBottom: "20px" }}
                    >
                      {mainData?.productLifecycleJourney?.productTests.name}
                    </div>
                    <div
                      className="pill"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      Not Available
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className="step"
                  onClick={() => openStepForProductTests()}
                  style={{ cursor: "pointer" }}
                  role="listitem"
                  aria-label={`Step ${mainData?.productLifecycleJourney?.productTests?.dppId}: ${mainData?.productLifecycleJourney?.productTests?.dppId}`}
                >
                  <div className="icon-wrap" style={{ marginBottom: "10px" }}>
                    <div
                      className="icon-circle timeline-icon"
                      style={{
                        background: "black",
                      }}
                    >
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#fff"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <Science color="white" />
                      </svg>
                    </div>
                    <div className="step-number">
                      {
                        mainData?.productLifecycleJourney?.productTests
                          .orderNumber
                      }
                    </div>
                  </div>

                  <div
                    className="timeline-line"
                    style={{ marginTop: "80px" }}
                  />
                  <div className="hl-connector"></div>
                  <div
                    className="card timeline-icon2"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "80px",
                      boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
                      padding: "20px",
                    }}
                  >
                    <div
                      className="card-title"
                      style={{ marginBottom: "20px" }}
                    >
                      {mainData?.productLifecycleJourney?.productTests.name}
                    </div>
                    <div
                      className="pill"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      {mainData?.productLifecycleJourney?.productTests.status
                        ? mainData?.productLifecycleJourney?.productTests.status
                        : "-"}
                    </div>
                  </div>
                </div>
              )}
            </>
          )}

          {viewValidation && (
            <>
              {mainData?.productLifecycleJourney?.technicalDocuments
                .orderNumber == "n/a" ||
                mainData?.productLifecycleJourney?.technicalDocuments
                  .orderNumber == "" ? (
                <div
                  className="step"
                  style={{ cursor: "default" }}
                  role="listitem"
                  aria-label={`Step ${mainData?.productLifecycleJourney?.technicalDocuments?.dppId}: ${mainData?.productLifecycleJourney?.technicalDocuments?.dppId}`}
                >
                  <div className="icon-wrap" style={{ marginBottom: "10px" }}>
                    <div
                      className="icon-circle "
                      style={{
                        background: "grey",
                      }}
                    >
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#fff"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <ArticleIcon color="white" />
                      </svg>
                    </div>
                  </div>

                  <div
                    className="timeline-line"
                    style={{ marginTop: "80px" }}
                  />
                  <div className="hl-connector"></div>
                  <div
                    className="card "
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "80px",
                      boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
                      padding: "20px",
                    }}
                  >
                    <div
                      className="card-title"
                      style={{ marginBottom: "20px" }}
                    >
                      {
                        mainData?.productLifecycleJourney?.technicalDocuments
                          .name
                      }
                    </div>
                    <div
                      className="pill"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      Not Available
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className="step"
                  onClick={() => openStepForTechnicalDocuments()}
                  style={{ cursor: "pointer" }}
                  role="listitem"
                  aria-label={`Step ${mainData?.productLifecycleJourney?.technicalDocuments?.dppId}: ${mainData?.productLifecycleJourney?.technicalDocuments?.dppId}`}
                >
                  <div className="icon-wrap" style={{ marginBottom: "10px" }}>
                    <div
                      className="icon-circle timeline-icon"
                      style={{
                        background: "#F59E0B",
                      }}
                    >
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#fff"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <ArticleIcon color="white" />
                      </svg>
                    </div>
                    <div className="step-number">
                      {
                        mainData?.productLifecycleJourney?.technicalDocuments
                          .orderNumber
                      }
                    </div>
                  </div>

                  <div
                    className="timeline-line"
                    style={{ marginTop: "80px" }}
                  />
                  <div className="hl-connector"></div>
                  <div
                    className="card timeline-icon2"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "80px",
                      boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
                      padding: "20px",
                    }}
                  >
                    <div
                      className="card-title"
                      style={{ marginBottom: "20px" }}
                    >
                      {
                        mainData?.productLifecycleJourney?.technicalDocuments
                          .name
                      }
                    </div>
                    <div
                      className="pill"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      {
                        mainData?.productLifecycleJourney?.technicalDocuments
                          .status
                      }
                    </div>
                  </div>
                </div>
              )}
            </>
          )}

          {viewCoc && (
            <>
              {mainData?.productLifecycleJourney?.chainOfCustody.orderNumber ==
                "n/a" ||
                mainData?.productLifecycleJourney?.chainOfCustody.orderNumber ==
                "" ? (
                <div
                  className="step"
                  style={{ cursor: "default" }}
                  role="listitem"
                  aria-label={`Step ${mainData?.productLifecycleJourney?.chainOfCustody?.dppId}: ${mainData?.productLifecycleJourney?.chainOfCustody?.dppId}`}
                >
                  <div className="icon-wrap" style={{ marginBottom: "10px" }}>
                    <div
                      className="icon-circle "
                      style={{
                        background: "grey",
                      }}
                    >
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#fff"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <LocalShippingIcon color="white" />
                      </svg>
                    </div>
                  </div>

                  <div
                    className="timeline-line"
                    style={{ marginTop: "80px" }}
                  />
                  <div className="hl-connector"></div>
                  <div
                    className="card "
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "80px",
                      boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
                      padding: "20px",
                    }}
                  >
                    <div
                      className="card-title"
                      style={{ marginBottom: "20px" }}
                    >
                      {mainData?.productLifecycleJourney?.chainOfCustody.name}
                    </div>
                    <div
                      className="pill"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      Not Available
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className="step"
                  onClick={() => openStepForCOC()}
                  style={{ cursor: "pointer" }}
                  role="listitem"
                  aria-label={`Step ${mainData?.productLifecycleJourney?.chainOfCustody?.dppId}: ${mainData?.productLifecycleJourney?.chainOfCustody?.dppId}`}
                >
                  <div className="icon-wrap" style={{ marginBottom: "10px" }}>
                    <div
                      className="icon-circle timeline-icon"
                      style={{
                        background:
                          mainData?.productLifecycleJourney?.chainOfCustody
                            ?.badgeColor,
                      }}
                    >
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#fff"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <LocalShippingIcon color="white" />
                      </svg>
                    </div>
                    <div className="step-number">
                      {
                        mainData?.productLifecycleJourney?.chainOfCustody
                          .orderNumber
                      }
                    </div>
                  </div>

                  <div
                    className="timeline-line"
                    style={{ marginTop: "80px" }}
                  />
                  <div className="hl-connector"></div>
                  <div
                    className="card timeline-icon2"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "80px",
                      boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
                      padding: "20px",
                    }}
                  >
                    <div
                      className="card-title"
                      style={{ marginBottom: "20px" }}
                    >
                      {mainData?.productLifecycleJourney?.chainOfCustody.name}
                    </div>
                    <div
                      className="pill"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      {mainData?.productLifecycleJourney?.chainOfCustody.status}
                    </div>
                  </div>
                </div>
              )}
            </>
          )}

          {viewDurability && (
            <>
              {mainData?.productLifecycleJourney?.durabilityAndLifespan
                .orderNumber == "n/a" ||
                mainData?.productLifecycleJourney?.durabilityAndLifespan
                  .orderNumber == "" ? (
                <div
                  className="step"
                  style={{ cursor: "default" }}
                  role="listitem"
                  aria-label={`Step ${mainData?.productLifecycleJourney?.durabilityAndLifespan?.dppId}: ${mainData?.productLifecycleJourney?.durabilityAndLifespan?.dppId}`}
                >
                  <div className="icon-wrap" style={{ marginBottom: "10px" }}>
                    <div
                      className="icon-circle "
                      style={{
                        background: "grey",
                      }}
                    >
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#fff"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <ShieldIcon color="white" />
                      </svg>
                    </div>
                  </div>

                  <div
                    className="timeline-line"
                    style={{ marginTop: "80px" }}
                  />
                  <div className="hl-connector"></div>
                  <div
                    className="card "
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "80px",
                      boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
                      padding: "20px",
                    }}
                  >
                    <div
                      className="card-title"
                      style={{ marginBottom: "20px" }}
                    >
                      {
                        mainData?.productLifecycleJourney?.durabilityAndLifespan
                          .name
                      }
                    </div>
                    <div
                      className="pill"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      Not Available
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className="step"
                  onClick={() => openStepForDurability()}
                  style={{ cursor: "pointer" }}
                  role="listitem"
                  aria-label={`Step ${mainData?.productLifecycleJourney?.durabilityAndLifespan?.dppId}: ${mainData?.productLifecycleJourney?.durabilityAndLifespan?.dppId}`}
                >
                  <div className="icon-wrap" style={{ marginBottom: "10px" }}>
                    <div
                      className="icon-circle timeline-icon"
                      style={{
                        background: "#A78BFA",
                      }}
                    >
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#fff"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <ShieldIcon color="white" />
                      </svg>
                    </div>
                    <div className="step-number">
                      {
                        mainData?.productLifecycleJourney?.durabilityAndLifespan
                          .orderNumber
                      }
                    </div>
                  </div>

                  <div
                    className="timeline-line"
                    style={{ marginTop: "80px" }}
                  />
                  <div className="hl-connector"></div>
                  <div
                    className="card timeline-icon2"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "80px",
                      boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
                      padding: "20px",
                    }}
                  >
                    <div
                      className="card-title"
                      style={{ marginBottom: "20px" }}
                    >
                      {
                        mainData?.productLifecycleJourney?.durabilityAndLifespan
                          .name
                      }
                    </div>
                    <div
                      className="pill"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      {
                        mainData?.productLifecycleJourney?.durabilityAndLifespan
                          .status
                      }
                    </div>
                  </div>
                </div>
              )}
            </>
          )}

          {viewRepairValue && (
            <>
              {mainData?.productLifecycleJourney?.returnRepairInfo
                .orderNumber == "n/a" ||
                mainData?.productLifecycleJourney?.returnRepairInfo.orderNumber ==
                "" ? (
                <div
                  className="step"
                  style={{ cursor: "default" }}
                  role="listitem"
                  aria-label={`Step ${mainData?.productLifecycleJourney?.returnRepairInfo?.dppId}: ${mainData?.productLifecycleJourney?.returnRepairInfo?.dppId}`}
                >
                  <div className="icon-wrap" style={{ marginBottom: "10px" }}>
                    <div
                      className="icon-circle "
                      style={{
                        background: "grey",
                      }}
                    >
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#fff"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <BuildIcon color="white" />
                      </svg>
                    </div>
                  </div>

                  <div
                    className="timeline-line"
                    style={{ marginTop: "80px" }}
                  />
                  <div className="hl-connector"></div>
                  <div
                    className="card "
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "80px",
                      boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
                      padding: "20px",
                    }}
                  >
                    <div
                      className="card-title"
                      style={{ marginBottom: "20px" }}
                    >
                      {mainData?.productLifecycleJourney?.returnRepairInfo.name}
                    </div>
                    <div
                      className="pill"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      Not Available
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className="step"
                  onClick={() => openStepForRCV()}
                  style={{ cursor: "pointer" }}
                  role="listitem"
                  aria-label={`Step ${mainData?.productLifecycleJourney?.returnRepairInfo?.dppId}: ${mainData?.productLifecycleJourney?.returnRepairInfo?.dppId}`}
                >
                  <div className="icon-wrap" style={{ marginBottom: "10px" }}>
                    <div
                      className="icon-circle timeline-icon"
                      style={{
                        background: "#60A5FA",
                      }}
                    >
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#fff"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <BuildIcon color="white" />
                      </svg>
                    </div>
                    <div className="step-number">
                      {
                        mainData?.productLifecycleJourney?.returnRepairInfo
                          .orderNumber
                      }
                    </div>
                  </div>

                  <div
                    className="timeline-line"
                    style={{ marginTop: "80px" }}
                  />
                  <div className="hl-connector"></div>
                  <div
                    className="card timeline-icon2"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "80px",
                      boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
                      padding: "20px",
                    }}
                  >
                    <div
                      className="card-title"
                      style={{ marginBottom: "20px" }}
                    >
                      {mainData?.productLifecycleJourney?.returnRepairInfo.name}
                    </div>
                    <div
                      className="pill"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      {
                        mainData?.productLifecycleJourney?.returnRepairInfo
                          .status
                      }
                    </div>
                  </div>
                </div>
              )}
            </>
          )}

          {viewPackaging && (
            <>
              {mainData?.productLifecycleJourney?.packagingWasteManagement
                .orderNumber == "n/a" ||
                mainData?.productLifecycleJourney?.packagingWasteManagement
                  .orderNumber == "" ? (
                <div
                  className="step"
                  style={{ cursor: "default" }}
                  role="listitem"
                  aria-label={`Step ${mainData?.productLifecycleJourney?.packagingWasteManagement?.dppId}: ${mainData?.productLifecycleJourney?.packagingWasteManagement?.dppId}`}
                >
                  <div className="icon-wrap" style={{ marginBottom: "10px" }}>
                    <div
                      className="icon-circle "
                      style={{
                        background: "grey",
                      }}
                    >
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#fff"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <FactoryIcon color="white" />
                      </svg>
                    </div>
                  </div>

                  <div
                    className="timeline-line"
                    style={{ marginTop: "80px" }}
                  />
                  <div className="hl-connector"></div>
                  <div
                    className="card "
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "80px",
                      boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
                      padding: "20px",
                    }}
                  >
                    <div
                      className="card-title"
                      style={{ marginBottom: "20px" }}
                    >
                      {
                        mainData?.productLifecycleJourney
                          ?.packagingWasteManagement.name
                      }
                    </div>
                    <div
                      className="pill"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      Not Available
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className="step"
                  onClick={() => openStepForPWM()}
                  style={{ cursor: "pointer" }}
                  role="listitem"
                  aria-label={`Step ${mainData?.productLifecycleJourney?.packagingWasteManagement?.dppId}: ${mainData?.productLifecycleJourney?.packagingWasteManagement?.dppId}`}
                >
                  <div className="icon-wrap" style={{ marginBottom: "10px" }}>
                    <div
                      className="icon-circle timeline-icon"
                      style={{
                        background: "#FF69B4",
                      }}
                    >
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#fff"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <FactoryIcon color="white" />
                      </svg>
                    </div>
                    <div className="step-number">
                      {
                        mainData?.productLifecycleJourney
                          ?.packagingWasteManagement.orderNumber
                      }
                    </div>
                  </div>

                  <div
                    className="timeline-line"
                    style={{ marginTop: "80px" }}
                  />
                  <div className="hl-connector"></div>
                  <div
                    className="card timeline-icon2"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "80px",
                      boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
                      padding: "20px",
                    }}
                  >
                    <div
                      className="card-title"
                      style={{ marginBottom: "20px" }}
                    >
                      {
                        mainData?.productLifecycleJourney
                          ?.packagingWasteManagement.name
                      }
                    </div>
                    <div
                      className="pill"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      {
                        mainData?.productLifecycleJourney
                          ?.packagingWasteManagement.status
                      }
                    </div>
                  </div>
                </div>
              )}
            </>
          )}

          {viewSocialCompliance && (
            <>
              {mainData?.productLifecycleJourney?.socialCompliance
                .orderNumber == "n/a" ||
                mainData?.productLifecycleJourney?.socialCompliance.orderNumber ==
                "" ? (
                <div
                  className="step"
                  style={{ cursor: "default" }}
                  role="listitem"
                  aria-label={`Step ${mainData?.productLifecycleJourney?.socialCompliance?.dppId}: ${mainData?.productLifecycleJourney?.socialCompliance?.dppId}`}
                >
                  <div className="icon-wrap" style={{ marginBottom: "10px" }}>
                    <div
                      className="icon-circle "
                      style={{
                        background: "grey",
                      }}
                    >
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#fff"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <EnergySavingsLeafIcon color="white" />
                      </svg>
                    </div>
                  </div>

                  <div
                    className="timeline-line"
                    style={{ marginTop: "80px" }}
                  />
                  <div className="hl-connector"></div>
                  <div
                    className="card "
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "80px",
                      boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
                      padding: "20px",
                    }}
                  >
                    <div
                      className="card-title"
                      style={{ marginBottom: "20px" }}
                    >
                      {mainData?.productLifecycleJourney?.socialCompliance.name}
                    </div>
                    <div
                      className="pill"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      Not Available
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className="step"
                  onClick={() => openStepForEvt()}
                  style={{ cursor: "pointer" }}
                  role="listitem"
                  aria-label={`Step ${mainData?.productLifecycleJourney?.socialCompliance?.dppId}: ${mainData?.productLifecycleJourney?.socialCompliance?.dppId}`}
                >
                  <div className="icon-wrap" style={{ marginBottom: "10px" }}>
                    <div
                      className="icon-circle timeline-icon"
                      style={{
                        background:
                          mainData?.productLifecycleJourney?.socialCompliance
                            ?.badgeColor,
                      }}
                    >
                      <svg
                        width="36"
                        height="36"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#fff"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <EnergySavingsLeafIcon color="white" />
                      </svg>
                    </div>
                    <div className="step-number">
                      {
                        mainData?.productLifecycleJourney?.socialCompliance
                          .orderNumber
                      }
                    </div>
                  </div>

                  <div
                    className="timeline-line"
                    style={{ marginTop: "80px" }}
                  />
                  <div className="hl-connector"></div>
                  <div
                    className="card timeline-icon2"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "80px",
                      boxShadow: "0 8px 20px rgba(2,6,23,0.08)",
                      padding: "20px",
                    }}
                  >
                    <div
                      className="card-title"
                      style={{ marginBottom: "20px" }}
                    >
                      {mainData?.productLifecycleJourney?.socialCompliance.name}
                    </div>
                    <div
                      className="pill"
                      style={{
                        borderColor: "#A78BFA",
                        color: "#A78BFA",
                        marginBottom: "10px",
                        borderRadius: "5px",
                      }}
                    >
                      {mainData?.productLifecycleJourney?.socialCompliance
                        .status
                        ? mainData?.productLifecycleJourney?.socialCompliance
                          .status
                        : "-"}
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>

        <div
          className="desktop-dots"
          role="tablist"
          aria-label="Timeline pagination"
        >
          {steps && steps.map((_, i) => (
            <button
              key={`dot-${i}`}
              type="button"
              className={`desktop-dot ${activeIndex === i ? "active" : ""}`}
              aria-label={`Go to slide ${i + 1}`}
              aria-current={activeIndex === i ? "true" : "false"}
              onClick={() => scrollToIndex(i)}
            />
          ))}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DesktopTimelineSlider);